import React from "react";
import { Route, useRouteMatch, Switch } from "polyrouter";
import SiteDetailsRouter from "./View/SiteDetailsRouter";
import { SiteList } from "./List/SiteList";
import { useTenantId } from "polyrouter/SelectedTenantProvider";

export const SiteRouter: React.FC = () => {
  const root = useRouteMatch().path;
  const tenantId = useTenantId();

  return (
    <Switch>
      <Route path={`${root}/details/:siteId`} component={SiteDetailsRouter} />
      <Route path={root} render={() => <SiteList tenantId={tenantId} />} />
    </Switch>
  );
};
